<template>
  <div class="page-content">
    <base-screen>
      <el-form
        size="medium"
        :inline="true"
        :model="screenData"
        ref="screenForm"
        @keydown.native.enter="screenSubmit"
        @submit.native.prevent>
        <el-form-item label="订单号：" prop="orderNo">
          <el-input type="text" v-model="screenData.orderNo" placeholder="订单号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="服务名：" prop="serviceName">
          <el-input type="text" v-model="screenData.serviceName" placeholder="服务名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="screenSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="loading">
        <el-table-column
          prop="name"
          label="员工名">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单号">
          <template slot-scope="{row}">
          <el-button type="text" class="link" @click="$router.push({path: `/member/orderDetail/${row.orderNo}`})" v-pms="'look'">{{row.orderNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="服务名">
        </el-table-column>
        <el-table-column
          prop="orderState"
          label="订单状态"
        >
           <span slot-scope="{row}">
                <icon-svg :icon-class="`${orderStatus[row.orderState].icon}`"></icon-svg>
                {{ orderStatus[row.orderState].name }}
              </span>
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="订单金额"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
         >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>

    </div>
  </div>
</template>

<script>
import {employee} from '../../api'
import {orderStatus} from '@/utils/constant'
export default {
  name: 'OrderEmployeeList',
  props: {
    employeeId: String
  },
  data () {
    return {
      orderStatus,
      loading: false,
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      screenData: {
        orderNo: '',
        serviceName: '',
        employeeId: '',
        orgCode: this.$store.state.user.orgCode
      }
    }
  },
  mounted () {
    this.screenData.employeeId = this.employeeId
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      let {data, page} = await employee.getOrderEmployeePage({
        page: this.page,
        param: this.screenData
      })
      this.loading = false
      this.tableData = data
      this.page = page
    },
    screenSubmit () {
      this.page['pageNum'] = 1
      this.getData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.page['pageNum'] = 1
      this.screenData.serviceName = ''
      this.screenData.orderNo = ''
      this.getData()
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    }
  }
}
</script>

<style scoped>
 .el-input {
   width: 300px;
 }
</style>
